import { render, staticRenderFns } from "./materialPop.vue?vue&type=template&id=53b60692"
import script from "./materialPop.vue?vue&type=script&lang=js"
export * from "./materialPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53b60692')) {
      api.createRecord('53b60692', component.options)
    } else {
      api.reload('53b60692', component.options)
    }
    module.hot.accept("./materialPop.vue?vue&type=template&id=53b60692", function () {
      api.rerender('53b60692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/material/materialPop.vue"
export default component.exports